import React from "react";

const LauchTiming = () => {
  return (
    <>
      <div
        id="ethCountdown"
        className="lauchTiming"
        style={{ display: "none", minWidth: 260 }}
      >
        <div className="header">landsale</div>
        <div className="body">
          <p>Starting Time</p>
          <h3 id="countDown"></h3>
        </div>
      </div>
    </>
  );
};

export default LauchTiming;
